import {
  CreateDamageExceptionActionForm,
  CreateDamageExceptionNoteForm,
  DamageExceptionFilterData,
  DamageExceptionDetailModel,
  DamageExceptionModel,
  UpdateDamageExceptionStatusForm,
  UploadDamageExceptionAttachmentForm,
  AppSearch,
  AppSearchResponse,
} from '@/types';
import {
  Core,
  DAMAGE_EXCEPTION,
  DAMAGE_EXCEPTION_FILTERS,
  DAMAGE_EXCEPTION_ACTION,
  DAMAGE_EXCEPTION_ATTACHMENT,
  DAMAGE_EXCEPTION_NOTE,
  DAMAGE_EXCEPTION_STATUS,
} from '../Core';

class DamageExceptions extends Core {
  getDamageExceptions = async (query: AppSearch<DamageExceptionModel>) =>
    this.post<AppSearchResponse<DamageExceptionModel>>(
      DAMAGE_EXCEPTION(),
      query,
    );

  getDamageExceptionFilters = async () =>
    this.get<DamageExceptionFilterData>(DAMAGE_EXCEPTION_FILTERS());

  getDamageExceptionById = async (id: number) =>
    this.get<DamageExceptionDetailModel>(DAMAGE_EXCEPTION(id));

  createDamageExceptionNote = async (data: CreateDamageExceptionNoteForm) =>
    this.post(DAMAGE_EXCEPTION_NOTE(), data);

  createDamageExceptionAction = async (data: CreateDamageExceptionActionForm) =>
    this.post(DAMAGE_EXCEPTION_ACTION(), data);

  updateDamageExceptionStatus = async (data: UpdateDamageExceptionStatusForm) =>
    this.patch(DAMAGE_EXCEPTION_STATUS(), data);

  uploadDamageExceptionAttachment = async (
    data: UploadDamageExceptionAttachmentForm,
  ) => this.post(DAMAGE_EXCEPTION_ATTACHMENT(), data);
}

export const damageExceptions = new DamageExceptions();
